import { useState } from 'preact/hooks';
import { websApi } from '@/api/webs';
import { useToast } from '@/hooks/useToast';
export function useOnlineEventSpeakers({ web, onPatchWeb, }) {
    const { showSuccess, showError } = useToast();
    const [showAddParticipant, setShowAddParticipant] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deletingParticipant, setDeletingParticipant] = useState(false);
    const [editingSpeaker, setEditingSpeaker] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const toSpeakerPatch = (speaker) => ({
        ContactId: speaker.ContactId || '',
        Name: speaker.Name,
        Email: speaker.Email,
        Title: speaker.Title,
        CompanyName: speaker.CompanyName,
        CompanyId: speaker.CompanyId || undefined,
        Bio: speaker.Bio || undefined,
        SpeakerType: speaker.SpeakerType,
    });
    const currentSpeakers = () => (web.OnlineEvent?.Speakers || []);
    const openEdit = (sp) => {
        setEditingSpeaker(sp);
        setShowEditModal(true);
    };
    const saveEditedSpeaker = async (upd) => {
        const patched = currentSpeakers().map(s => s.ContactId === upd.ContactId
            ? { ...s, SpeakerType: upd.SpeakerType, CompanyId: upd.CompanyId || null, CompanyName: upd.CompanyName, Email: upd.Email, Title: upd.Title, Bio: upd.Bio || null }
            : s);
        const res = await websApi.patchSpeakers(web.WorkspaceId, web.Id, web.ETag, patched.map(toSpeakerPatch));
        if (!res.error && res.data) {
            onPatchWeb(prev => ({ ...prev, ...res.data }));
            showSuccess('Participant updated', 'Changes saved.');
        }
        else {
            showError('Update failed', res.error || 'Unable to update participant');
        }
    };
    const addSpeakerAndPersist = async (spk) => {
        const existing = currentSpeakers().map(toSpeakerPatch);
        const res = await websApi.patchSpeakers(web.WorkspaceId, web.Id, web.ETag, [...existing, toSpeakerPatch(spk)]);
        if (!res.error && res.data) {
            onPatchWeb(prev => ({ ...prev, ...res.data }));
            showSuccess('Participant added', 'Speaker list updated.');
        }
        else {
            showError('Add failed', res.error || 'Unable to add participant');
        }
    };
    const deleteSpeakerAndPersist = async (contactId) => {
        setDeletingParticipant(true);
        const remaining = currentSpeakers()
            .filter(s => (s.ContactId || '') !== contactId)
            .map(toSpeakerPatch);
        const res = await websApi.patchSpeakers(web.WorkspaceId, web.Id, web.ETag, remaining);
        setDeletingParticipant(false);
        if (!res.error && res.data) {
            onPatchWeb(prev => ({ ...prev, ...res.data }));
            showSuccess('Participant removed', 'Speaker list updated.');
            return true;
        }
        showError('Delete failed', res.error || 'Unable to remove participant');
        return false;
    };
    const handleSaveReorder = async (patchItems) => {
        const res = await websApi.patchSpeakers(web.WorkspaceId, web.Id, web.ETag, patchItems);
        if (!res.error && res.data) {
            onPatchWeb(prev => ({ ...prev, ...res.data }));
            showSuccess('Order saved', 'Speaker order updated.');
            return true;
        }
        else if (res.status !== 422)
            showError('Save failed', res.error || 'Unable to reorder speakers');
        return false;
    };
    return {
        showAddParticipant,
        setShowAddParticipant,
        deleteTarget,
        setDeleteTarget,
        deletingParticipant,
        editingSpeaker,
        showEditModal,
        setShowEditModal,
        openEdit,
        saveEditedSpeaker,
        addSpeakerAndPersist,
        deleteSpeakerAndPersist,
        handleSaveReorder,
    };
}
